import React from 'react';
import { z } from 'zod';
import { COLOR_SCHEMA } from '../color';
import { getPadding, PADDING_SCHEMA } from '../padding';
export const LogoPropsSchema = z.object({
    style: z
        .object({
        backgroundColor: COLOR_SCHEMA,
        textAlign: z.enum(['left', 'right', 'center']).optional().nullable(),
        padding: PADDING_SCHEMA,
    })
        .optional()
        .nullable(),
    props: z
        .object({
        logo: z.string().optional().nullable(),
        logos: z.object({}).optional(),
        width: z.number().optional().nullable(),
        height: z.number().optional().nullable(),
        contentAlignment: z.enum(['top', 'middle', 'bottom']).optional().nullable(),
    })
        .optional()
        .nullable(),
});
export function Logo({ style, props }) {
    var _e, _t, _y, _10, _11, _12, _13;
    const cssStyle = {
        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_t = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _t !== void 0 ? _t : undefined,
        padding: getPadding(style === null || style === void 0 ? void 0 : style.padding),
    };
    const width = (_y = props === null || props === void 0 ? void 0 : props.width) !== null && _y !== void 0 ? _y : undefined;
    const height = (_10 = props === null || props === void 0 ? void 0 : props.height) !== null && _10 !== void 0 ? _10 : undefined;
    const selectedLogo = props === null || props === void 0 ? void 0 : props.logos[props === null || props === void 0 ? void 0 : props.logo];
    const imageElement = (React.createElement("img", { alt: (_11 = selectedLogo === null || selectedLogo === void 0 ? void 0 : selectedLogo.alt) !== null && _11 !== void 0 ? _11 : '', src: (_12 = selectedLogo === null || selectedLogo === void 0 ? void 0 : selectedLogo.url) !== null && _12 !== void 0 ? _12 : '', width: width, height: height, style: {
            width,
            height,
            outline: 'none',
            border: 'none',
            textDecoration: 'none',
            verticalAlign: (_13 = props === null || props === void 0 ? void 0 : props.contentAlignment) !== null && _13 !== void 0 ? _13 : 'middle',
            display: 'inline-block',
            maxWidth: '100%',
        } }));
    return React.createElement("div", { style: cssStyle }, imageElement);
}
//# sourceMappingURL=Logo.js.map